import { Rule } from "src/types/rule";

export const searchForRule = (search: string, rule: Rule): boolean =>
  searchInString(search, rule.name) ||
  searchInString(search, rule.code) ||
  (!!rule.description && searchInString(search, rule.description));

const searchInString = (search: string, value: string): boolean =>
  value.toLowerCase().includes(search.toLowerCase());
